const BASE_URL = process.env.REACT_APP_BACKEND_URL

const REPORTS_URL = `${BASE_URL}reports/`
const REPORT_ASSIGNS_URL_PER_USER = `${BASE_URL}reportassigns?fetch=per_user`
const ADMIN_REPORTS = `${BASE_URL}reportassigns`
const REPORT_TYPES = `${BASE_URL}reporttypes`
const STATUS_UPDATES = `${BASE_URL}statusupdates`
const RESOLVED_REPORTS = `${BASE_URL}resolvedreports/`
const OUTCOMES = `${BASE_URL}outcomes`
const REPORT_ASSIGNS_URL = `${BASE_URL}reportassigns`

export default {
  REPORTS_URL,
  REPORT_ASSIGNS_URL_PER_USER,
  ADMIN_REPORTS,
  REPORT_TYPES,
  STATUS_UPDATES,
  RESOLVED_REPORTS,
  OUTCOMES,
  REPORT_ASSIGNS_URL,
}
